// extracted by mini-css-extract-plugin
export var skipAnimation = "_x-0";